import ArrowIcon from '@/public/assets/ui-icons/arrow.svg';
import { sendAnalyticsEvent } from '@/utils/Analytics';
import { FAQDataItem } from '@/utils/faq/FaqFormatter';

const FAQItem = ({ question, answer }: FAQDataItem) => {
  const handleClick = () => {
    sendAnalyticsEvent('faq-click', { title: question });
  };

  return (
    <details className="group rounded-[12px] bg-blue-grey-200 py-4 px-5">
      <summary className="flex cursor-pointer list-none justify-between gap-2" onClick={handleClick}>
        <span className="text-base font-medium leading-5 text-grey-900">{question}</span>
        <ArrowIcon className="h-5 w-5 shrink-0 group-open:rotate-180" />
      </summary>
      <div className="mt-3 text-sm font-normal text-grey-700">{answer}</div>
    </details>
  );
};

export default FAQItem;
